








import BookingDetail from "@/components/booking/customer/BookingDetail.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { AvailabilityModule } from "@/store/modules/availability.store";
import { Component, Vue } from "vue-property-decorator";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";

@Component({
  components: {
    LayoutReportWithBanner,
    BookingDetail
  }
})
export default class BookingDetailView extends Vue {
  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get bookingId() {
    return this.$route.params["id"];
  }

  get partnerId() {
    return ReportModule.partner?._id || PartnerModule.partner?._id;
  }

  async mounted() {
    const booking = await AvailabilityModule.findOneBookingByPartner({ partnerId: this.partnerId, id: this.bookingId });

    await AvailabilityModule.findOneByPartner({
      partnerId: this.partnerId,
      id: booking.serviceId || "",
      date: new Date().toISOString()
    });
  }
}
